import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

const echo = new Echo({
    broadcaster: 'pusher',
    key: '39419725a56e7552923e',
    cluster: 'us2',
    forceTLS: true
});

export default echo;